"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 *
 * @param {String} updatedClassName
 *
 * @returns null if no className is passed
 * @returns string of cleaned up className. Removes extra spaces, trims ends.
 */
var CleanUpClassName = function CleanUpClassName(updatedClassName) {
  if (!updatedClassName || updatedClassName.length === 0) {
    return null;
  } else {
    var finalClassName = updatedClassName.trim(' ').split(/\s+/).join(' ');
    return finalClassName;
  }
};
var _default = exports["default"] = CleanUpClassName;